import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";

import {
  ADD_TO_CART,
  DELETE_CART,
  EMPTY_CART,
  INCREASE_ITEM_QUANTITY,
  DECREASE_ITEM_QUANTITY,
  CLEAR_CART,
  GET_CHECKOUT_QUESTIONS,
} from "../types";

const initialState = {
  cartItems: [],
  orderItems: [],
  checkoutQuestions: [],
  simulatedFinal: 0,
  tipDetails: null,
  cartDetails: null,
  tableDetails: null,
  addressDetails: null,
  extendLoading: false,
  endLoading: false,
  orderType: null,
  addOnsDetail: [],
  allTablesData: {},
};
let cart = [];
export default function cartReducer(
  state = initialState,
  { type, payload, action }
) {
  const calculateTotalPrice = (item) => {
    const addonsTotal = (item.selectedAddons || []).reduce(
      (sum, addon) => sum + addon.price * addon.quantity,
      0
    );
    return item.price * item.quantity + addonsTotal;
  };

  switch (type) {
    case ADD_TO_CART: {
      const cartItemWithId = {
        ...payload,
        cartItemId:
          Date.now().toString() + Math.random().toString(36).substring(2, 9),
      };

      return {
        ...state,
        cartItems: [...(state.cartItems || []), cartItemWithId],
      };
    }

    case "ADD_TO_ORDER": {
      const { value, size } = payload; // value is now like "itemID__size"

      const existingIndex = state.orderItems.findIndex(
        (item) => item.value === value && item.size === size
      );

      if (existingIndex !== -1) {
        const updatedItems = [...state.orderItems];
        const existingItem = updatedItems[existingIndex];
        const updatedQuantity = existingItem.quantity + 1;

        updatedItems[existingIndex] = {
          ...existingItem,
          quantity: updatedQuantity,
          totalPrice: (
            updatedQuantity * parseFloat(existingItem.price || 0)
          ).toFixed(2),
        };

        return { ...state, orderItems: updatedItems };
      }

      const newItem = {
        ...payload,
        orderItemID: uuidv4(), // assign a true unique ID here only when creating a *new* item
        quantity: 1,
      };

      return {
        ...state,
        orderItems: [...state.orderItems, newItem],
      };
    }

    case "ADD_OR_UPDATE_ADDON": {
      const { orderItemID, addon } = payload;

      const updatedOrderItems = state.orderItems.map((item) => {
        if (item.orderItemID === orderItemID) {
          const selectedAddons = item.selectedAddons || [];

          const existingIndex = selectedAddons.findIndex(
            (a) => a.id === addon.id
          );

          let updatedAddons;
          if (existingIndex !== -1) {
            //Update quantity
            updatedAddons = [...selectedAddons];
            updatedAddons[existingIndex] = {
              ...updatedAddons[existingIndex],
              quantity: (updatedAddons[existingIndex].quantity || 0) + 1,
            };
          } else {
            //Add new addon with default quantity
            updatedAddons = [
              ...selectedAddons,
              {
                id: addon.id,
                name: addon.name,
                price: addon.price,
                quantity: 1,
              },
            ];
            toast.success("Addon added successfully");
          }

          return {
            ...item,
            selectedAddons: updatedAddons,
            totalPrice: calculateTotalPrice({
              ...item,
              selectedAddons: updatedAddons,
            }),
          };
        }
        return item;
      });

      return {
        ...state,
        orderItems: updatedOrderItems,
      };
    }

    case "INCREASE_ADDON_QTY": {
      const { orderItemID, addonID } = payload;
      const updatedOrderItems = state.orderItems.map((item) => {
        if (item.orderItemID === orderItemID) {
          const updatedAddons = item.selectedAddons.map((addon) => {
            if (addon.id === addonID) {
              return { ...addon, quantity: addon.quantity + 1 };
            }
            return addon;
          });
          return {
            ...item,
            selectedAddons: updatedAddons,
            totalPrice: calculateTotalPrice({
              ...item,
              selectedAddons: updatedAddons,
            }),
          };
        }
        return item;
      });
      return { ...state, orderItems: updatedOrderItems };
    }

    case "DECREASE_ADDON_QTY": {
      const { orderItemID, addonID } = payload;
      const updatedOrderItems = state.orderItems.map((item) => {
        if (item.orderItemID === orderItemID) {
          const updatedAddons = item.selectedAddons
            .map((addon) => {
              if (addon.id === addonID) {
                if (addon.quantity > 1) {
                  return { ...addon, quantity: addon.quantity - 1 };
                }
                return null; // remove if quantity 1
              }
              return addon;
            })
            .filter(Boolean); // remove nulls
          return {
            ...item,
            selectedAddons: updatedAddons,
            totalPrice: calculateTotalPrice({
              ...item,
              selectedAddons: updatedAddons,
            }),
          };
        }
        return item;
      });
      return { ...state, orderItems: updatedOrderItems };
    }

    case "REMOVE_FROM_ORDER": {
      return {
        ...state,
        orderItems: state.orderItems.filter(
          (item) => item.orderItemID !== payload
        ),
      };
    }

    case "FETCH_ALL_TABLES_SUCCESS":
      return {
        ...state,
        allTablesData: payload,
      };

    case "CART_DETAILS":
      return {
        ...state,
        cartDetails: payload,
      };

    case "END_LOADING":
      return {
        ...state,
        endLoading: {
          ...state.endLoading,
          [payload.tableId]: payload.loading,
        },
      };
    case "EXTEND_LOADING":
      return {
        ...state,
        extendLoading: {
          ...state.extendLoading,
          [payload.tableId]: payload.loading,
        },
      };

    case "CHANGE_ORDER_TYPE":
      return {
        ...state,
        orderType: payload,
      };
    case "FETCH_ADD_ONS":
      return {
        ...state,
        addOnsDetail: payload,
      };

    case INCREASE_ITEM_QUANTITY: {
      const { cartItemId, orderItemID, size, type = "cartItem" } = payload;

      const targetKey = type === "cartItem" ? "cartItems" : "orderItems";
      const idKey = type === "cartItem" ? "cartItemId" : "orderItemID";
      const matchId = type === "cartItem" ? cartItemId : orderItemID;

      const updatedItems = state[targetKey].map((item) => {
        if (item[idKey] === matchId && item.size === size) {
          const updatedQuantity = item.quantity + 1;
          const totalPrice = parseFloat(item.totalPrice || "0");
          const unitPrice = parseFloat(item.price || "0");

          return {
            ...item,
            quantity: updatedQuantity,
            totalPrice: (totalPrice + unitPrice).toFixed(2),
          };
        }
        return item;
      });

      return {
        ...state,
        [targetKey]: updatedItems,
      };
    }

    case DECREASE_ITEM_QUANTITY: {
      const { cartItemId, orderItemID, size, type = "cartItem" } = payload;

      const targetKey = type === "cartItem" ? "cartItems" : "orderItems";
      const idKey = type === "cartItem" ? "cartItemId" : "orderItemID";
      const matchId = type === "cartItem" ? cartItemId : orderItemID;

      const updatedItems = state[targetKey].map((item) => {
        if (item[idKey] === matchId && item.size === size) {
          const updatedQuantity = Math.max(item.quantity - 1, 0);
          const totalPrice = parseFloat(item.totalPrice || "0");
          const unitPrice = parseFloat(item.price || "0");

          return {
            ...item,
            quantity: updatedQuantity,
            totalPrice: (totalPrice - unitPrice).toFixed(2),
          };
        }
        return item;
      });

      return {
        ...state,
        [targetKey]: updatedItems,
      };
    }

    case "UPDATE_SIMULATED":
      const updatedSimulatedFinal = payload;
      return {
        ...state,
        simulatedFinal: updatedSimulatedFinal,
      };

    case DELETE_CART:
      cart = [...state.cartItems];
      const cartDeleteIndex = cart?.findIndex(
        (val) =>
          val?.cartItemId === payload.cartItemId && val.size === payload.size
      );

      cart.splice(cartDeleteIndex, 1);
      return {
        ...state,
        cartItems: cart,
      };

    case EMPTY_CART:
      return {
        ...state,
        cartItems: [],
      };
    case "EMPTY_ORDER":
      return {
        ...state,
        orderItems: [],
      };

    case CLEAR_CART:
      return {
        ...state,
        cartItems: [],
        tipDetails: null,
        tableDetails: null,
      };
    case "CLEAR_CART_DETAILS":
      return {
        ...state,
        cartDetails: null,
      };
    case GET_CHECKOUT_QUESTIONS: {
      return {
        ...state,
        checkoutQuestions: payload,
      };
    }
    case "TIP_DETAILS": {
      return {
        ...state,
        tipDetails: payload,
      };
    }
    case "TABLE_UPDATE": {
      return {
        ...state,
        tableDetails: payload,
      };
    }
    case "DELIVERY_UPDATE": {
      return {
        ...state,
        addressDetails: payload,
      };
    }
    case "UPDATE_ITEM_INSTRUCTIONS": {
      const { orderItemID, instructions } = payload;
      return {
        ...state,
        orderItems: state.orderItems.map((item) =>
          item.orderItemID === orderItemID ? { ...item, instructions } : item
        ),
      };
    }
    default:
      return { ...state };
  }
}
